import React, {useState, memo, useCallback, useEffect, useMemo, forwardRef, useImperativeHandle} from "../../../__snowpack__/pkg/react.js";
import {message, Popover, Checkbox, Spin, Button, Row} from "../../../__snowpack__/pkg/antd.js";
import {SettingOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {axios} from "../../lib/axios.js";
import styled, {createGlobalStyle} from "../../../__snowpack__/pkg/styled-components.js";
import {localeMessage} from "./i18n.js";
import {useIntlTyped} from "../../lib/useIntlTyped.js";
const CheckboxGroup = Checkbox.Group;
export const CustomColumnSetting = memo(forwardRef((props, ref) => {
  const [visable, setVisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isBthLoading, setIsBthLoading] = useState(false);
  const [defaultCheckedList, setDefaultCheckedList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);
  const [checkIndex, setCheckIndex] = useState(0);
  const {messages, formatMessageMock, formatMessage, formatMessageRaw, locale} = useIntlTyped(localeMessage);
  useMemo(() => {
    let check = !!checkedList.length && checkedList.length < defaultCheckedList.length;
    setIndeterminate(check);
    setCheckAll(checkedList.length === defaultCheckedList.length);
  }, [checkedList]);
  useImperativeHandle(ref, () => ({
    handleQuery
  }));
  const handleQuery = useCallback(async () => {
    setIsLoading(true);
    let params = {
      ...props.apiParam
    };
    let apiMethod = props.apiMethod || "get";
    let queryPromise;
    if (props.formatParam) {
      params = props.formatParam(params);
    }
    if (apiMethod === "get") {
      queryPromise = axios[apiMethod](props.apiUrl, {
        params
      });
    } else {
      queryPromise = axios[apiMethod](props.apiUrl, params);
    }
    queryPromise.then((data) => {
      setIsLoading(false);
      if (data.code === "SUCCESS") {
        let dataSource = props.filterDataSource && props.filterDataSource(data?.data);
        setDefaultCheckedList(dataSource);
        let checkList = dataSource?.filter((item) => item.check)?.map((item) => item.name);
        setCheckedList(checkList);
        props.onRenderTableColum(checkList);
      } else {
        message.error(data.message);
      }
    });
  }, [props.apiUrl, defaultCheckedList, props.apiParam]);
  const handleOk = useCallback(async () => {
    try {
      setIsBthLoading(true);
      props.handleLoading(true);
      if (!props.saveUrl)
        return;
      let params = {
        ...props.apiParam,
        configValue: defaultCheckedList.map((item) => {
          return {
            name: item.label,
            disable: item.disable,
            includeList: item.includeList,
            check: checkedList.includes(item.name)
          };
        })
      };
      let apiMethod = props.apiMethod || "get";
      let queryPromise;
      if (props.formatParam) {
        params = props.formatParam(params);
      }
      if (apiMethod === "get") {
        queryPromise = axios[apiMethod](props.saveUrl, {
          params
        });
      } else {
        queryPromise = axios[apiMethod](props.saveUrl, params);
      }
      queryPromise.then((data) => {
        setIsBthLoading(false);
        props.handleLoading(false);
        if (data.code === "SUCCESS") {
          setVisable(!visable);
          message.success(props.successTips || data.message);
          props.onHanleSuccessCallback && props.onHanleSuccessCallback();
        } else {
          message.error(data.message);
          props.onHanleFailCallback && props.onHanleFailCallback();
        }
        props.onHanleOkCallback && props.onHanleOkCallback();
        let checkList = defaultCheckedList?.filter((item) => item.check)?.map((item) => item.name);
        props.onRenderTableColum(checkList);
      }).catch((errorInfo) => {
        message.error(errorInfo.toString());
      });
    } catch (error) {
      message.error(error.toString());
    }
  }, [props.saveUrl, defaultCheckedList, props.apiParam]);
  const onChange = (checkedList2) => {
    setCheckedList(checkedList2);
    defaultCheckedList.map((item) => {
      item.check = checkedList2.includes(item.name);
    });
    setDefaultCheckedList([...defaultCheckedList]);
  };
  const onCheckAllChange = (e) => {
    setCheckedList(e?.target?.checked ? defaultCheckedList.map((item) => item.name) : defaultCheckedList.filter((item) => item.disabled).map((_item) => _item.name));
    defaultCheckedList.map((item) => {
      item.check = e?.target?.checked || item.disabled;
    });
    setDefaultCheckedList([...defaultCheckedList]);
  };
  const handleDragEnd = (e, i) => {
    if (i == checkIndex) {
      return;
    }
    let checkedList2 = JSON.parse(JSON.stringify(defaultCheckedList));
    const fromObj = checkedList2.splice(i, 1)[0];
    checkedList2.splice(checkIndex, 0, fromObj);
    setCheckedList(checkedList2?.filter((item) => item.check)?.map((item) => item.name));
    setDefaultCheckedList(checkedList2);
  };
  const handleDrag = (e, toIdx) => {
    setCheckIndex(toIdx);
  };
  const text = /* @__PURE__ */ React.createElement(Checkbox, {
    indeterminate,
    onChange: onCheckAllChange,
    checked: checkAll
  }, formatMessage({id: "selectall"}));
  const content = /* @__PURE__ */ React.createElement(Spin, {
    spinning: isLoading
  }, /* @__PURE__ */ React.createElement("div", {
    className: "customColumWrapper"
  }, /* @__PURE__ */ React.createElement(CheckboxGroup, {
    value: checkedList,
    onChange
  }, defaultCheckedList.map((item, i) => /* @__PURE__ */ React.createElement(Row, {
    key: item.name,
    draggable: true,
    onDragEnd: ($event) => {
      handleDragEnd($event, i);
    },
    onDragOver: (e) => {
      e.preventDefault();
      handleDrag(e, i);
    }
  }, props.tableColumConfigInfo[item.name]?.title && /* @__PURE__ */ React.createElement(Checkbox, {
    value: item.name,
    disabled: item.disabled
  }, /* @__PURE__ */ React.createElement("span", null, props.tableColumConfigInfo && props.tableColumConfigInfo[item.name]?.title))))), /* @__PURE__ */ React.createElement("div", {
    className: "operation-container"
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => {
      setVisable(!visable);
    }
  }, formatMessage({id: "status_cancelled"})), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: handleOk,
    loading: isBthLoading
  }, formatMessage({id: "confirm"})))));
  useEffect(() => {
    handleQuery();
    props.onHandleEffect && props.onHandleEffect();
  }, [props.apiUrl, props.depQuery]);
  return /* @__PURE__ */ React.createElement(Popover, {
    placement: "leftBottom",
    title: text,
    content,
    trigger: "click",
    visible: visable,
    onVisibleChange: () => {
      setVisable(!visable);
    }
  }, /* @__PURE__ */ React.createElement(GlobalStyle, null), /* @__PURE__ */ React.createElement(Button, {
    type: "text",
    icon: /* @__PURE__ */ React.createElement(SettingOutlined, null),
    onClick: () => {
      setVisable(!visable);
    }
  }, formatMessage({id: "customColumnSettings"})));
}));
const GlobalStyle = createGlobalStyle`
.customColumWrapper{
  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    max-height: 275px;
    overflow: scroll;
    .ant-row  {
      margin: 1px;
    }
  }
  .ant-checkbox-wrapper {
      margin-bottom: 3px;
      padding: 2px;
    }
    .operation-container {
      display: flex;
      justify-content: space-around;
      padding: 6px;
    }
    .ant-row:hover {
      background-color: #f5f5f5;
      border-radius: 3px;
      box-shadow: 0 0.1em 0.5em #f5f5f5;
      transition: all .3s;
    }
}
`;
const Wrapper = styled.span`
  padding: 8px;
  cursor: pointer;
  font-size: 18px;
  color: #6020ff;
`;
